export default __webpack_public_path__ + "static/pragicts-our-perspectives-banner-afterthought-2339c30936278515cf84ab4a22dff9d5.jpg";